import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

/**
 * Renders a monetary figure, or a mask when the API has withheld it.
 *
 * The API sends `null` for a balance the current user may not see, which is deliberately NOT the same
 * as zero. This pipe is the single place that turns that null into something on screen, so a redaction
 * always looks like a redaction and never like an empty account.
 *
 * ```html
 * {{ account.currentBalance | maskedAmount }}          <!-- 5,000.00  or  •••••• -->
 * {{ account.currentBalance | maskedAmount: '1.0-0' }}
 * ```
 */
@Pipe({
  name: 'maskedAmount',
  standalone: true,
})
export class MaskedAmountPipe implements PipeTransform {
  /** Six dots regardless of the underlying magnitude — a mask whose length tracked the number would
   * leak how large it is. */
  static readonly MASK = '••••••';

  constructor(private readonly decimalPipe: DecimalPipe) {}

  transform(value: number | null | undefined, digitsInfo = '1.2-2'): string {
    if (value === null || value === undefined) {
      return MaskedAmountPipe.MASK;
    }
    return this.decimalPipe.transform(value, digitsInfo) ?? MaskedAmountPipe.MASK;
  }
}
